import { Skeleton } from '@/components/ui/skeleton';

export const ChecklistSkeleton = () => {
  return (
    <section className="w-full">
      <div className="pt-5 px-5 pb-8">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200">
          <div className="border-b border-gray-200">
            <nav className="flex -mb-px">
              <div className="px-6 py-3">
                <Skeleton className="h-5 w-20" />
              </div>
              <div className="px-6 py-3">
                <Skeleton className="h-5 w-24" />
              </div>
            </nav>
          </div>

          <div className="p-6">
            <div className="space-y-4">
              {[1, 2, 3, 4, 5, 6, 7].map(i => (
                <div key={i} className="bg-white rounded-xl shadow-sm border border-gray-200">
                  <div className="flex flex-col md:flex-row items-start md:items-center justify-between p-4 gap-4">
                    <div className="flex items-start md:items-center gap-3 flex-1 w-full">
                      <Skeleton className="h-5 w-5 flex-shrink-0 mt-1 md:mt-0" />
                      <div className="space-y-2 flex-1 w-full">
                        <Skeleton className="h-5 w-full md:w-64" />
                        <Skeleton className="h-3 w-3/4 md:w-96" />
                      </div>
                    </div>
                    <div className="flex items-center gap-4 w-full md:w-auto justify-between md:justify-end">
                      <Skeleton className="h-4 w-16" />
                      <Skeleton className="h-2 w-24 rounded-full" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="border-t border-gray-200 p-6">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <Skeleton className="h-4 w-32" />
              <div className="flex items-center gap-4 w-full md:w-auto justify-end">
                <Skeleton className="h-3 w-24" />
                <Skeleton className="h-8 w-16" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
